import accountHealth from './accountHealth.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import branchRoutes from './branchRoutes.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import productTour from './productTour.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import scheduledReport from './scheduledReport.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import settingsCommand from './settingsCommand.json';
import setupChecklist from './setupChecklist.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import workflows from './workflows.json';

export default {
  ...accountHealth,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...branchRoutes,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...productTour,
  ...report,
  ...resetPassword,
  ...scheduledReport,
  ...search,
  ...setNewPassword,
  ...settings,
  ...settingsCommand,
  ...setupChecklist,
  ...signup,
  ...teamsSettings,
  ...whatsappTemplates,
  ...workflows,
};
